import { MenuItem, TextField } from "@mui/material";
import React, { useEffect } from "react";
//@ts-ignore
import { DateTime } from 'luxon';
import { UcSelectFormikProps } from "./UcSelectFormik";

export const UcSelectBillingCycle = (props: UcSelectFormikProps) => {
    const isReady = !!props.form.values;
    const defaultValue = props.field.value ?? (props.options.length > 0 ? props.options[0].value : '');

    useEffect(() => {
        const fieldValueDate = props.field.value ? DateTime.fromISO(props.field.value) : null;
        let closestMonthOption = null;

        // Check if the current value matches any option exactly
        const exactMatchExists = props.options.some(option => option.value === props.field.value);

        if (!exactMatchExists && fieldValueDate && props.options.length > 0) {
            // Find the closest billing cycle that contains the current date
            closestMonthOption = props.options.find(option => {
                const cycleStartDate = DateTime.fromISO(option.value);
                const cycleEndDate = cycleStartDate.plus({ months: 1 });
                return fieldValueDate >= cycleStartDate && fieldValueDate < cycleEndDate;
            });
        }

        // If no exact match exists and a closest option is found, update the field value
        if (!exactMatchExists && closestMonthOption) {
            props.form.setFieldValue(props.field.name, closestMonthOption.value);
        } else if (!props.field.value && props.options.length > 0) {
            props.form.setFieldValue(props.field.name, props.options[0].value);
        }

    }, [props.field.name, props.field.value, props.form, props.options]);

    if (!isReady) {
        return <></>;
    }

    return <TextField
        select
        data-cy-id={"ucSelectBillingCycle-textField"}
        name={props.field.name}
        value={defaultValue}
        onChange={props.field.onChange}
        sx={{ width: 300 }}
        SelectProps={{ MenuProps: { sx: { maxHeight: 400 } } }}
        {...props}
    >
        {props.options?.map((option: any) => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        ))}
    </TextField>;
};

export default UcSelectBillingCycle;